import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 's1ReadableDate'
})
export class S1ReadableDatePipe implements PipeTransform  {

  private datePipe: DatePipe;

  constructor() {
    this.datePipe = new DatePipe('it');
  }

  transform(date: Date, ...args: unknown[]): string {

    if (!date) {
      return null
    }

    if (args.length > 0 && args[0]) { // se passo true come parametro metto anche l'ora
      return this.datePipe.transform(date, 'dd/MM/yyyy HH:mm:ss')
    }

    return this.datePipe.transform(date, 'dd/MM/yyyy')

  }

}